/* eslint-disable no-restricted-syntax */
<template>
  <div class="cotacoes">
    <div class="row m-0" v-if="cotacoes != []">
      <div class="col-12 p-0" v-for="(cotacao, index) in cotacoes" :key="index">
        <h2
          class="title text-uppercase font-weight-bold"
          v-bind:class="{ 'm-t-50': index > 0 }"
        >
          Cotação Nº {{ cotacao.id }}
          <div
            class="btn bg-orange c-pointer c-white c-white-hover"
            @click="seeQuote(cotacao.id)"
          >
            Ver Cotação
          </div>
          <div
            class="btn bg-orange c-pointer c-white c-white-hover m-l-7px"
            @click="seeSaler(cotacao.usuario.id, cotacao.tipo)"
          >
            Ver Cotador
          </div>
          <div
            class="btn bg-orange c-pointer c-white c-white-hover m-l-7px"
            @click="deleteQuote(cotacao.id)"
          >
            Deletar Cotação
          </div>
        </h2>
        <hr class="linha-amarela" />
        <div class="lista-r" v-if="cotacao.todasRespostas">
          <h5>Usuários que responderam</h5>
          <table class="table">
            <thead class="c-white bg-gren-dark">
              <tr class="text-uppercase">
                <th>Código</th>
                <th>
                  <div v-if="cotacao.tipo_usuario_id === 1">Cliente</div>
                  <div v-if="cotacao.tipo_usuario_id === 2">Profissional</div>
                  <div v-if="cotacao.tipo_usuario_id === 3">Lojista</div>
                  <div v-if="cotacao.tipo_usuario_id === 4">Representante</div>
                </th>
                <th>CPF</th>
                <th>CNPJ</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(resposta, index) in cotacao.todasRespostas"
                :key="index"
              >
                <td>{{ resposta.id }}</td>
                <td>
                  <div
                    v-if="
                      cotacao.usuario.usuario_id !==
                      resposta.cot_usuario_receb_resp_id
                    "
                  >
                    <div
                      v-if="
                        resposta.cot_usuario_recebedor_dados.dadosCliente !==
                        null
                      "
                    >
                      {{
                        resposta.cot_usuario_recebedor_dados.dadosCliente.nome
                      }}
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados.dadosLojista !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .nome_fantasia !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .nome_fantasia
                        }}
                      </div>
                      <div
                        v-else-if="
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .razao_social !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .razao_social
                        }}
                      </div>
                      <div v-else>
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .nome_responsavel
                        }}
                      </div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados
                          .dadosProfissional !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .nome_fantasia !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .nome_fantasia
                        }}
                      </div>
                      <div v-else>
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .nome
                        }}
                      </div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados
                          .dadosRepresentante !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.nome_fantasia !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.nome_fantasia
                        }}
                      </div>
                      <div
                        v-else-if="
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.razao_social !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.razao_social
                        }}
                      </div>
                      <div v-else>
                        {{
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.nome_responsavel
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      cotacao.usuario.usuario_id !==
                      resposta.cot_usuario_respondeu_id
                    "
                  >
                    <div
                      v-if="
                        resposta.cot_usuario_enviador_dados.dadosCliente !==
                        null
                      "
                    >
                      {{
                        resposta.cot_usuario_enviador_dados.dadosCliente.nome
                      }}
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados.dadosLojista !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .nome_fantasia !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .nome_fantasia
                        }}
                      </div>
                      <div
                        v-else-if="
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .razao_social !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .razao_social
                        }}
                      </div>
                      <div v-else>
                        {{
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .nome_responsavel
                        }}
                      </div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados
                          .dadosProfissional !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .nome_fantasia !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .nome_fantasia
                        }}
                      </div>
                      <div v-else>
                        {{
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .nome
                        }}
                      </div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados
                          .dadosRepresentante !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .nome_fantasia !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .nome_fantasia
                        }}
                      </div>
                      <div
                        v-else-if="
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .razao_social !== null
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .razao_social
                        }}
                      </div>
                      <div v-else>
                        {{
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .nome_responsavel
                        }}
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    v-if="
                      cotacao.usuario.usuario_id !==
                      resposta.cot_usuario_receb_resp_id
                    "
                  >
                    <div
                      v-if="
                        resposta.cot_usuario_recebedor_dados.dadosCliente !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados.dadosCliente
                            .cpf !== null &&
                          resposta.cot_usuario_recebedor_dados.dadosCliente
                            .cpf !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosCliente.cpf
                        }}
                      </div>
                      <div v-else>Sem Cpf</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados.dadosLojista !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .cpf !== null &&
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .cpf !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosLojista.cpf
                        }}
                      </div>
                      <div v-else>Sem Cpf</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados
                          .dadosProfissional !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .cpf !== null &&
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .cpf !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .cpf
                        }}
                      </div>
                      <div v-else>Sem Cpf</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados
                          .dadosRepresentante !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.cpf !== null &&
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.cpf !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.cpf
                        }}
                      </div>
                      <div v-else>Sem Cpf</div>
                    </div>
                  </div>
                  <div
                    v-if="
                      cotacao.usuario.usuario_id !==
                      resposta.cot_usuario_respondeu_id
                    "
                  >
                    <div
                      v-if="
                        resposta.cot_usuario_enviador_dados.dadosCliente !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosCliente
                            .cpf !== null &&
                          resposta.cot_usuario_enviador_dados.dadosCliente
                            .cpf !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosCliente.cpf
                        }}
                      </div>
                      <div v-else>Sem Cpf</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados.dadosLojista !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .cpf !== null &&
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .cpf !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosLojista.cpf
                        }}
                      </div>
                      <div v-else>Sem Cpf</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados
                          .dadosProfissional !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .cpf !== null &&
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .cpf !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .cpf
                        }}
                      </div>
                      <div v-else>Sem Cpf</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados
                          .dadosRepresentante !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .cpf !== null &&
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .cpf !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .cpf
                        }}
                      </div>
                      <div v-else>Sem Cpf</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    v-if="
                      cotacao.usuario.usuario_id !==
                      resposta.cot_usuario_receb_resp_id
                    "
                  >
                    <div
                      v-if="
                        resposta.cot_usuario_recebedor_dados.dadosCliente !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados.dadosCliente
                            .cnpj !== null &&
                          resposta.cot_usuario_recebedor_dados.dadosCliente
                            .cnpj !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosCliente.cnpj
                        }}
                      </div>
                      <div v-else>Sem Cnpj</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados.dadosLojista !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .cnpj !== null &&
                          resposta.cot_usuario_recebedor_dados.dadosLojista
                            .cnpj !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosLojista.cnpj
                        }}
                      </div>
                      <div v-else>Sem Cnpj</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados
                          .dadosProfissional !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .cnpj !== null &&
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .cnpj !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados.dadosProfissional
                            .cnpj
                        }}
                      </div>
                      <div v-else>Sem Cnpj</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados
                          .dadosRepresentante !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.cnpj !== null &&
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.cnpj !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_recebedor_dados
                            .dadosRepresentante.cnpj
                        }}
                      </div>
                      <div v-else>Sem Cnpj</div>
                    </div>
                  </div>
                  <div
                    v-if="
                      cotacao.usuario.usuario_id !==
                      resposta.cot_usuario_respondeu_id
                    "
                  >
                    <div
                      v-if="
                        resposta.cot_usuario_enviador_dados.dadosCliente !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosCliente
                            .cnpj !== null ||
                          resposta.cot_usuario_enviador_dados.dadosCliente
                            .cnpj !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosCliente.cnpj
                        }}
                      </div>
                      <div v-else>Sem Cnpj</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados.dadosLojista !==
                        null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .cnpj !== null ||
                          resposta.cot_usuario_enviador_dados.dadosLojista
                            .cnpj !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosLojista.cnpj
                        }}
                      </div>
                      <div v-else>Sem Cnpj</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados
                          .dadosProfissional !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .cnpj !== null ||
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .cnpj !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosProfissional
                            .cnpj
                        }}
                      </div>
                      <div v-else>Sem Cnpj</div>
                    </div>
                    <div
                      v-else-if="
                        resposta.cot_usuario_enviador_dados
                          .dadosRepresentante !== null
                      "
                    >
                      <div
                        v-if="
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .cnpj !== null ||
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .cnpj !== ''
                        "
                      >
                        {{
                          resposta.cot_usuario_enviador_dados.dadosRepresentante
                            .cnpj
                        }}
                      </div>
                      <div v-else>Sem Cnpj</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    class="btn bg-orange c-white c-white-hover text-uppercase"
                    @click="seeQuoteAnswer(resposta.id)"
                  >
                    Ver Cotação
                  </div>

                  <span
                    v-if="
                      cotacao.usuario.usuario_id !==
                      resposta.cot_usuario_receb_resp_id
                    "
                  >
                    <span
                      v-if="
                        resposta.cot_usuario_recebedor_dados.dadosCliente !==
                        null
                      "
                    >
                      <div
                        class="btn bg-orange c-white c-white-hover text-uppercase m-l-7px"
                        @click="
                          seeSaler(
                            resposta.cot_usuario_recebedor_dados.dadosCliente
                              .id,
                            'cliente'
                          )
                        "
                      >
                        Ver Cliente
                      </div>
                    </span>
                    <span
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados.dadosLojista !==
                        null
                      "
                    >
                      <div
                        class="btn bg-orange c-white c-white-hover text-uppercase m-l-7px"
                        @click="
                          seeSaler(
                            resposta.cot_usuario_recebedor_dados.dadosLojista
                              .id,
                            'lojista'
                          )
                        "
                      >
                        Ver Lojista
                      </div>
                    </span>
                    <span
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados
                          .dadosProfissional !== null
                      "
                    >
                      <div
                        class="btn bg-orange c-white c-white-hover text-uppercase m-l-7px"
                        @click="
                          seeSaler(
                            resposta.cot_usuario_recebedor_dados
                              .dadosProfissional.id,
                            'profissional'
                          )
                        "
                      >
                        Ver Profissional
                      </div>
                    </span>
                    <span
                      v-else-if="
                        resposta.cot_usuario_recebedor_dados
                          .dadosRepresentante !== null
                      "
                    >
                      <div
                        class="btn bg-orange c-white c-white-hover text-uppercase m-l-7px"
                        @click="
                          seeSaler(
                            resposta.cot_usuario_recebedor_dados
                              .dadosRepresentante.id,
                            'representante'
                          )
                        "
                      >
                        Ver Representante
                      </div>
                    </span>
                  </span>

                  <span
                    v-if="
                      cotacao.usuario.usuario_id !==
                      resposta.cot_usuario_respondeu_id
                    "
                  >
                    <span
                      v-if="
                        resposta.cot_usuario_enviador_dados.dadosCliente !==
                        null
                      "
                    >
                      <div
                        class="btn bg-orange c-white c-white-hover text-uppercase m-l-7px"
                        @click="
                          seeSaler(
                            resposta.cot_usuario_enviador_dados.dadosCliente.id,
                            'cliente'
                          )
                        "
                      >
                        Ver Cliente
                      </div>
                    </span>
                    <span
                      v-else-if="
                        resposta.cot_usuario_enviador_dados.dadosLojista !==
                        null
                      "
                    >
                      <div
                        class="btn bg-orange c-white c-white-hover text-uppercase m-l-7px"
                        @click="
                          seeSaler(
                            resposta.cot_usuario_enviador_dados.dadosLojista.id,
                            'lojista'
                          )
                        "
                      >
                        Ver Lojista
                      </div>
                    </span>
                    <span
                      v-else-if="
                        resposta.cot_usuario_enviador_dados
                          .dadosProfissional !== null
                      "
                    >
                      <div
                        class="btn bg-orange c-white c-white-hover text-uppercase m-l-7px"
                        @click="
                          seeSaler(
                            resposta.cot_usuario_enviador_dados
                              .dadosProfissional.id,
                            'profissional'
                          )
                        "
                      >
                        Ver Profissional
                      </div>
                    </span>
                    <span
                      v-else-if="
                        resposta.cot_usuario_enviador_dados
                          .dadosRepresentante !== null
                      "
                    >
                      <div
                        class="btn bg-orange c-white c-white-hover text-uppercase m-l-7px"
                        @click="
                          seeSaler(
                            resposta.cot_usuario_enviador_dados
                              .dadosRepresentante.id,
                            'representante'
                          )
                        "
                      >
                        Ver Representante
                      </div>
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="lista-n-r" :ref="'linr' + index">
          <h5>Usuários que não responderam</h5>
          <table class="table">
            <thead class="c-white bg-red-dark">
              <tr class="text-uppercase">
                <th>
                  <div v-if="cotacao.tipo_usuario_id === 1">Cliente</div>
                  <div v-if="cotacao.tipo_usuario_id === 2">Profissional</div>
                  <div v-if="cotacao.tipo_usuario_id === 3">Lojista</div>
                  <div v-if="cotacao.tipo_usuario_id === 4">Representante</div>
                </th>
                <th>E-mail</th>
                <th>Cpf</th>
                <th>Cnpj</th>
                <th>Telefone</th>
                <th>Celular</th>
              </tr>
            </thead>
            <tbody
              v-if="cotacao.tipo_usuario_id === 3 && usuariosLojistas !== false"
            >
              <tr
                v-for="(usuario, index) in usuariosLojistas"
                :key="index"
                v-if="
                  usuario.informacoes !== null &&
                  usuario.informacoes.segmentos !== null &&
                  verifyIfExistsInCidade(
                    usuario.informacoes.cidade_id,
                    cotacao.cidades
                  ) &&
                  verifyIfExistsInSegmento(
                    usuario.informacoes.segmentos,
                    cotacao.segmentos
                  ) &&
                  verifyIfExistsInRespostas(usuario.id, cotacao.todasRespostas)
                "
              >
                <!--  -->
                <td>
                  <div v-if="usuario.nome_usuario !== null">
                    {{ usuario.nome_usuario }}
                  </div>
                </td>
                <td>{{ usuario.email }}</td>
                <td>{{ usuario.cpf }}</td>
                <td>{{ usuario.cnpj }}</td>
                <td>
                  <div v-if="usuario.informacoes">
                    {{ usuario.informacoes.telefone }}
                  </div>
                </td>
                <td>
                  <div v-if="usuario.informacoes">
                    {{ usuario.informacoes.celular }}
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
            </tbody>
            <tbody
              v-else-if="
                cotacao.tipo_usuario_id === 4 &&
                usuariosRepresentantes !== false
              "
            >
              <tr
                v-for="(usuario, index) in usuariosRepresentantes"
                :key="index"
                v-if="
                  usuario.informacoes !== null &&
                  usuario.informacoes.segmentos !== null &&
                  verifyIfExistsInCidade(
                    usuario.informacoes.cidade_id,
                    cotacao.cidades
                  ) &&
                  verifyIfExistsInSegmento(
                    usuario.informacoes.segmentos,
                    cotacao.segmentos
                  ) &&
                  verifyIfExistsInRespostas(usuario.id, cotacao.todasRespostas)
                "
              >
                <td>
                  <div v-if="usuario.nome_usuario !== null">
                    {{ usuario.nome_usuario }}
                  </div>
                </td>
                <td>{{ usuario.email }}</td>
                <td>{{ usuario.cpf }}</td>
                <td>{{ usuario.cnpj }}</td>
                <td>
                  <div v-if="usuario.informacoes">
                    {{ usuario.informacoes.telefone }}
                  </div>
                </td>
                <td>
                  <div v-if="usuario.informacoes">
                    {{ usuario.informacoes.celular }}
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div class="ver-mais-lnr w-100 text-center">
            <div
              class="btn bg-orange c-white c-white-hover text-uppercase c-pointer"
              :ref="'linr-sall' + index"
              @click="showAll(index)"
            >
              Ver Mais
            </div>
            <div
              class="btn bg-orange c-white c-white-hover text-uppercase c-pointer d-none"
              :ref="'linr-dsall' + index"
              @click="disableShowAll(index)"
            >
              Ver Menos
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from 'Mixins/makeToast';

export default {
  name: 'cotacoes-geral',
  mixins: [makeToast],
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cotacoes: (state) => state.cotacoes,
      usuarios: (state) => state.usuarios,
      usuariosLojistas: (state) => {
        if (state.usuarios !== []) {
          return state.usuarios.filter(
            (usuarios) => usuarios.tipo_usuario_id == 3
          );
        }

        return false;
      },
      usuariosRepresentantes: (state) => {
        if (state.usuarios !== []) {
          return state.usuarios.filter(
            (usuarios) => usuarios.tipo_usuario_id == 4
          );
        }

        return false;
      },
    }),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.$store.dispatch('emptyCotacao');
    this.$store.dispatch('emptyUsuarios');

    Promise.all([
      this.$store.dispatch('showUsuariosGeral'),
      this.$store.dispatch('showCotacoesGeral'),
    ])
      .catch(() => {
        this.makeToast(
          'Oopss',
          'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined' ||
        value === []
      ) {
        return true;
      }
      return false;
    },
    filterByUsuarios(obj) {
      if ('tipo_usuario_id' in obj && typeof obj.tipo_usuario_id === 'number') {
        if (obj.tipo_usuario_id !== 3) {
          return obj.tipo_usuario_id;
        }
      }
    },
    verifyIfExistsInObject(id, array) {
      let result = true;

      if (array.length > 0) {
        for (const obj of array) {
          if (obj.cot_usuario_receb_resp_id === id) {
            result = false;
          } else if (obj.cot_usuario_respondeu_id === id) {
            result = false;
          }
        }
      }
      return result;
    },
    verifyIfExistsInSegmento(arrayOne, arraySecond) {
      // console.log(`Usuario segmentos: ${arrayOne} || Cotação segmentos: ${arraySecond}`);
      let result = false;

      if (!this.checkIsEmpty(arrayOne) && !this.checkIsEmpty(arraySecond)) {
        if (arrayOne.length > 0 && arraySecond.length > 0) {
          for (const arrOne of arrayOne) {
            for (const arrSecond of arraySecond) {
              if (arrOne.segmento_id === arrSecond.segmento.id) {
                result = true;
              }
            }
          }
        }
      }

      return result;
    },
    verifyIfExistsInCidade(cidade, array) {
      let result = false;

      if (!this.checkIsEmpty(cidade) && !this.checkIsEmpty(array)) {
        if (array.length > 0) {
          for (const obj of array) {
            if (!this.checkIsEmpty(obj.cidade)) {
              if (obj.cidade.id === cidade) {
                // console.log(`obj.cidade.id = ${obj.cidade.id} || Cidade = ${cidade}`);
                result = true;
              }
            }
          }
        }
      }

      return result;
    },
    verifyIfExistsInRespostas(usuarioVerificado, usuariosRespostas) {
      if (
        !this.checkIsEmpty(usuarioVerificado) &&
        !this.checkIsEmpty(usuariosRespostas)
      ) {
        if (usuariosRespostas.length > 0) {
          for (const usuario of usuariosRespostas) {
            if (!this.checkIsEmpty(usuario)) {
              const idUsuario =
                usuario.cot_usuario_id !== usuario.cot_usuario_receb_resp_id
                  ? usuario.cot_usuario_receb_resp_id
                  : usuario.cot_usuario_respondeu_id;
              if (usuarioVerificado !== idUsuario) {
                return true;
              }
              return false;
            }
          }
        } else {
          return true;
        }
      }

      return false;
    },
    showAll(id) {
      let reference;

      reference = this.$refs[`linr-sall${id}`];
      for (const ref of reference) {
        ref.classList.add('d-none');
      }

      reference = this.$refs[`linr-dsall${id}`];
      for (const ref of reference) {
        ref.classList.remove('d-none');
      }

      reference = this.$refs[`linr${id}`];
      for (const ref of reference) {
        ref.classList.add('active');
      }
    },
    disableShowAll(id) {
      let reference;

      reference = this.$refs[`linr-dsall${id}`];
      for (const ref of reference) {
        ref.classList.add('d-none');
      }

      reference = this.$refs[`linr-sall${id}`];
      for (const ref of reference) {
        ref.classList.remove('d-none');
      }

      reference = this.$refs[`linr${id}`];
      for (const ref of reference) {
        ref.classList.remove('active');
      }
    },
    seeSaler(id, tipo) {
      if (tipo === 'cliente' || tipo === 1) {
        this.$router.push({
          name: 'administrador-ver-cliente',
          params: { id },
        });
      } else if (tipo === 'lojista' || tipo === 3) {
        this.$router.push({
          name: 'administrador-ver-lojista',
          params: { id },
        });
      } else if (tipo === 'profissional' || tipo === 2) {
        this.$router.push({
          name: 'administrador-ver-profissional',
          params: { id },
        });
      } else if (tipo === 'representante' || tipo === 4) {
        this.$router.push({
          name: 'administrador-ver-representante',
          params: { id },
        });
      }
    },
    seeQuote(id) {
      this.$router.push({ name: 'administrador-cotacao', params: { id } });
    },
    seeQuoteAnswer(id) {
      this.$router.push({
        name: 'administrador-cotacoes-resposta',
        params: { id },
      });
    },
    deleteQuote(id) {
      if (window.confirm('Deseja deletar essa cotação?')) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('deleteQuote', id)
          .then(() => {
            this.makeToast('Sucesso!', 'Cotação Deletada com sucesso!');

            this.$store
              .dispatch('emptyCotacao')
              .then(() => {
                this.$store.dispatch('startLoader');
                this.$store.dispatch('showCotacoesGeral');
              })
              .catch(() => {
                this.makeToast(
                  'Oopss!',
                  'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                  'danger'
                );
              });
          })
          .catch(() => {
            this.makeToast(
              'Oopss!',
              'Algo de errado aconteceu ao deletar a cotação',
              'danger'
            );
          })
          .finally(() => this.$store.dispatch('endLoader'));
      }
    },
  },
};
</script>

<style>
@import '../../../custom/css/ver-cotacoes-usuarios.css';

.lista-r {
  transition: max-height 1s ease-in-out;
  overflow: hidden;
}

.lista-r.active {
  max-height: 100%;
  transition: max-height 1s ease-in-out;
}

.lista-n-r {
  max-height: 280px;
  transition: max-height 1s ease-in-out;
  overflow: hidden;
}

.lista-n-r.active {
  max-height: 100%;
  transition: max-height 1s ease-in-out;
}

.ver-mais-lnr {
  background: rgb(255, 255, 255);
  position: absolute;
  bottom: 6px;
}
</style>
